import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../../../redux/investigation/actions";
import "../FilesPreview/filePreview.scss";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import FilePreviewTable from "../../../components/Table/FilePreviewTable";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import Label from "../../../components/Label/Label";
import CloseIcon from "@mui/icons-material/Close";

const DataPreviewDialog = ({
  openDataPreviewDialog,
  closeDataPreviewDrawer,
  projectName,
}) => {
  const listData = useSelector(
    (state) => state?.investigation?.filesForPreviewData?.data
  );
  const Dispatch = useDispatch();

  const [outputData, setOutputData] = useState([]);

  const apiStatus = useSelector(
    (state) => state?.investigation?.filesForPreviewData
  );
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);

  useEffect(() => {
    Dispatch(acts.ClearGetFilesForPreviewApiStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (projectName) {
      const data = {
        page: 1,
        page_size: 500,
        fileType: "",
        formattedStartDate: "",
        formattedEndDate: "",
        type: "project",
        value: projectName,
      };
      Dispatch(acts.getFilesForPreview(data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectName]);

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.apiError === true && apiStatus?.next === false) {
        setMessage(apiStatus?.message);
        setErr(true);
      }
    }
  }, [apiStatus]);

  useEffect(() => {
    setOutputData(listData?.data);
  }, [listData]);

  return (
    <>
      <Dialog
        fullWidth={true}
        open={openDataPreviewDialog}
        onClose={() => closeDataPreviewDrawer()}
        PaperProps={{ style: { minHeight: "calc(100% - 10px)" } }}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        maxWidth="xl"
      >
        <DialogTitle id="scroll-dialog-title" sx={{ padding: "5px  20px " }}>
          Data Preview
          <IconButton
            aria-label="close"
            onClick={closeDataPreviewDrawer}
            className="close-icon"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers={"paper"}>
          <Box className="files-list dashboard-wrap">
            {apiStatus?.loader ? (
              <DashboardTableSkaleton />
            ) : outputData?.length ? (
              <FilePreviewTable data={outputData} />
            ) : (
              !apiStatus?.loader && (
                <div className="no-data">
                  <Label
                    text="No Data Found"
                    fontSize="16"
                    fontWeight="600"
                    padding="20px"
                  />
                </div>
              )
            )}
          </Box>
        </DialogContent>
      </Dialog>

      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}
    </>
  );
};

export default DataPreviewDialog;
